/* global google */

import LZ from 'lz-string'
import { apiGet, apiPost } from 'tennders-stracture/libs/api'
import { calcCrowDistance } from './utils'

export const compressRoute = async (originalRoute, directions) => LZ.compressToEncodedURIComponent(JSON.stringify({
  routes: [originalRoute],
  request: directions.original.request
}))

function mapSteps(steps) {
  return steps.map((s) => {
    const step = { ...s }
    step.end_location = new google.maps.LatLng(step.end_location.lat, step.end_location.lng)
    step.end_point = new google.maps.LatLng(step.end_point.lat, step.end_point.lng)
    step.start_location = new google.maps.LatLng(step.start_location.lat, step.start_location.lng)
    step.start_point = new google.maps.LatLng(step.start_point.lat, step.start_point.lng)

    step.lat_lngs = step.lat_lngs.map((lat_lng) => new google.maps.LatLng(lat_lng.lat, lat_lng.lng))

    if (step.path) {
      step.path = step.path.map((path_item) => new google.maps.LatLng(path_item.lat, path_item.lng))
    }

    if (step.steps) {
      step.steps = mapSteps(step.steps)
    }

    return step
  })
}

/**
 *  this functions regenerated directions object to use it
 *
 * @param directions
 * @returns {{request: (*&{origin: {location: google.maps.LatLng}, destination: {location: google.maps.LatLng}}), routes}}
 */
export function deserializeDirectionsResultOther(directions) {
  return {
    request: {
      ...directions.request,
      destination: { location: new google.maps.LatLng(directions.request.destination.location.lat, directions.request.destination.location.lng) },
      origin: { location: new google.maps.LatLng(directions.request.origin.location.lat, directions.request.origin.location.lng) }
    },
    routes: directions.routes.map((r) => {
      const route = { ...r }
      if (route.bounds) {
        route.bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(route.bounds.south, route.bounds.west),
          new google.maps.LatLng(route.bounds.north, route.bounds.east)
        )
      }

      route.legs = route.legs.map((l) => {
        const leg = { ...l }
        leg.end_location = new google.maps.LatLng(leg.end_location.lat, leg.end_location.lng)
        leg.start_location = new google.maps.LatLng(leg.end_location.lat, leg.end_location.lng)

        leg.steps = mapSteps(leg.steps)
        return leg
      })

      return route
    })
  }
}

// Takes serialized directionResult object string as input.
// Returns directionResult object.
export function deserializeDirectionsResult(serializedResult, google) {
  const serialArray = serializedResult.split('`')
  const travMode = serialArray[1]
  const directionsRequest = {
    travelMode: travMode,
    origin: new google.maps.LatLng(serialArray[2], serialArray[3]),
    destination: new google.maps.LatLng(serialArray[4], serialArray[5])
  }
  const directionsResult = {}
  directionsResult.request = directionsRequest
  directionsResult.routes = []
  directionsResult.routes[0] = { summary: serialArray[7] }
  // eslint-disable-next-line prefer-destructuring
  directionsResult.routes[0].copyrights = serialArray[0]
  directionsResult.routes[0].legs = []
  directionsResult.routes[0].legs[0] = {}
  directionsResult.routes[0].legs[0].start_location = directionsRequest.origin
  directionsResult.routes[0].legs[0].end_location = directionsRequest.destination
  directionsResult.routes[0].legs[0].steps = []
  const deserializedSteps = JSON.parse(serialArray[6])
  for (let i = 0; i < deserializedSteps.length; i += 1) {
    const dirStep = {}
    dirStep.path = []
    for (let c = 0; c < deserializedSteps[i].length; c += 1) {
      const { lat } = deserializedSteps[i][c]
      const { lng } = deserializedSteps[i][c]
      const theLatLng = new google.maps.LatLng(lat, lng)
      dirStep.path.push(theLatLng)
    }
    dirStep.travel_mode = travMode
    directionsResult.routes[0].legs[0].steps.push(dirStep)
  }
  return directionsResult
}

export const calculateRouteResults = (route) => {
  const routeResult = {
    distance: 0,
    duration: 0,
    distanceKm: 0,
    // eslint-disable-next-line
    name: route["summary"]
  }
  route.legs.forEach((leg) => {
    routeResult.distance += leg.distance?.value || 0
    routeResult.duration += leg.duration?.value || 0
  })

  return {
    ...routeResult,
    distanceKm: routeResult.distance / 1000
  }
}

/**
 * this function fetches the previously saved route details
 * from database and decompresses it
 * todo: change endpoint
 *
 * @param selectedRouteId
 * @returns {Promise<{decoded: any, created_at: *}|boolean>}
 */
export const fetchAndUncompressRouteDetails = async (selectedRouteId) => {
  const data = await apiGet(`/offers/route-details/${selectedRouteId}`)

  if (data.details) {
    const uncompressed = LZ.decompressFromEncodedURIComponent(data.details.compressed)
    const decoded = JSON.parse(uncompressed)
    return {
      details: decoded,
      created_at: data.details.created_at
    }
  }

  return false
}

/**
 * this functions will map waypoints into place object which google maps can show
 *
 * @param waypoints
 */
export const mapPlacesFromWaypoints = (waypoints) => waypoints.map((waypoint, i) => ({
  location: waypoint,
  id: i.toString(),
  marker: {
    icon: {
      url: '/img/truck.svg',
      scaledSize: {
        width: 30,
        height: 30
      }
    }
  }
}))

/**
 * this will map directions into object that we can show as route options
 *
 * @param directions
 * @param selectedRoute
 * @returns {*[]|*}
 */
export const mapDirectionsToRoutes = (directions, selectedRoute) => {
  if (!directions) {
    return []
  }

  return directions.routes.map((route, i) => ({
    color: i === parseInt(selectedRoute, 10) ? '#266fd3' : '#b0b2b4',
    label: `${route.name} - ${Math.floor(route.distanceKm)}KM`,
    name: route.name,
    km: route.distanceKm,
    isSelected: i === parseInt(selectedRoute, 10),
    value: i
  }))
}

/**
 *
 *
 * @param directions
 * @param selectedRouteIndex
 * @param routes
 * @returns {{summary, alternatives: number, details: {bounds: google.maps.LatLngBounds, overview_polyline: string}, selectedRouteIndex}|null}
 */
export const getCurrentRouteFromDetails = (directions, selectedRouteIndex, routes) => {
  if (!directions || (directions && typeof directions.original.routes[selectedRouteIndex])) {
    const details = directions.original.routes[selectedRouteIndex]
    const { overview_polyline, bounds } = details
    return {
      summary: directions.routes[selectedRouteIndex],
      details: { overview_polyline, bounds },
      alternatives: routes.length - 1,
      selectedRouteIndex
    }
  }

  return null
}

/**
 * this function will be used to saving route detaiks
 * todo: change endpoint
 * this return the if of newly selected route details
 *
 * @param id
 * @param details
 * @returns {Promise<boolean>}
 */
export const saveRouteDetails = async (id, details) => {
  try {
    await apiPost(`/offers/route-details/${id}`, { compressed: details })

    return id
  } catch (e) {
    return false
  }
}

export const generateWaypointsFromPickupAndDelivery = (form) => {
  const { pickupStops } = form
  const { deliveryStops } = form
  const ways = form.pickupRoute?.location ? [
    {
      lat: form.pickupRoute.location.lat || form.pickupRoute.location.latitude,
      lng: form.pickupRoute.location.lng || form.pickupRoute.location.longitude
    }
  ] : []

  if (pickupStops) {
    for (let i = 0; i < pickupStops.length; i += 1) {
      if (pickupStops[i].location) {
        const pickupLocation = pickupStops[i].location
        ways.push({
          lat: pickupLocation.latitude || pickupLocation.lat,
          lng: pickupLocation.longitude || pickupLocation.lng
        })
      }
    }
  }

  if (form.deliveryRoute?.location) {
    ways.push({
      lat: form.deliveryRoute.location.lat || form.deliveryRoute.location.latitude,
      lng: form.deliveryRoute.location.lng || form.deliveryRoute.location.longitude
    })
  }

  if (deliveryStops) {
    for (let i = 0; i < deliveryStops.length; i += 1) {
      if (deliveryStops[i].location) {
        const deliveryLocation = deliveryStops[i].location

        ways.push({
          lat: deliveryLocation.latitude || deliveryLocation.lat,
          lng: deliveryLocation.longitude || deliveryLocation.lng
        })
      }
    }
  }

  return ways
}

export const filterByDistance = (location, items, distance) => items.filter((item) => {
  if (!item?.pickupRoute) {
    return false
  }
  const { lat, lng } = item.pickupRoute.location
  const dist = calcCrowDistance(lat, lng, location?.lat, location?.lng)

  return distance > dist || distance < 0
})

export const filterByDate = (dayDiff, items) => items.filter((item) => `${dayDiff}` === 'false' || (dayDiff >= item.dayDiff && (!item.dayDiff2 || dayDiff <= item.dayDiff2)))
